module.exports = __webpack_public_path__ + "static/media/Price-detailsIcon.2ed25fc7.png";